import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

function loadView(name) {
    return () =>
        import(/* webpackChunkName: "[request]" */ `@/views/${name}`).then(
            (m) => m.default
        );
}

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: loadView('Home'),
        },
        {
            path: '/retailers',
            name: 'retailers',
            component: loadView('Retailers'),
        },
        {
            path: '/partners',
            name: 'partners',
            component: loadView('Partners'),
        },
        {
            path: '/card',
            name: 'card',
            component: loadView(''),
        },
        {
            path: '/card/balance',
            name: 'card-balance',
            component: loadView('card/Balance'),
        },
        {
            path: '/card/combine',
            name: 'card-combine',
            component: loadView('card/Combine'),
            props: true,
        },
        {
            path: '/support',
            name: 'support',
            component: loadView('Support'),
        },
        {
            path: '/contact',
            name: 'contact',
            component: loadView('Contact'),
        },
        {
            path: '/where_to_buy',
            name: 'contact',
            redirect: () => {
                window.location.replace('/retailers');
            },
        },
        {
            path: '/where_to_use',
            name: 'contact',
            redirect: () => {
                window.location.replace('/partners ');
            },
        },
        {
            path: '/cards/check_balance',
            name: 'contact',
            redirect: () => {
                window.location.replace('/card/balance');
            },
        },
        {
            path: '/how_it_works',
            name: 'contact',
            redirect: () => {
                window.location.replace('/support');
            },
        },
        {
            path: '*',
            name: 'page-not-found',
            component: loadView('PageNotFound'),
        },
    ],
    scrollBehavior() {
        //(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },
});
